	export default defineAppConfig({
	ui: {
		icons: {
		loading: 'line-md:loading-loop',
		close: 'tabler:x',
		minus: 'tabler:minus',
		chevronDown: 'tabler:chevron-down',
		chevronUp: 'tabler:chevron-up',
		chevronLeft: 'tabler:chevron-left',
		chevronRight: 'tabler:chevron-right',
		chevronDoubleLeft: 'tabler:chevrons-left',
		chevronDoubleRight: 'tabler:chevrons-right',
		search: 'tabler:search',
		searchIcon: 'tabler:search',
		selectedIcon: 'tabler:circle-check-filled',
		clearIcon: 'tabler:x'
		},

		toast: {
		slots: {
			root: 'gap-1.5',
			close: '*:size-4'
		}
		},

		skeleton: {
		base: 'bg-elevated/50'
		},

		tabs: {
			slots: {
				trigger: 'data-[state=inactive]:cursor-pointer',
			}
		},

		tooltip: {
			slots: {
				//  z-10
				content: 'h-auto z-2',
				text: 'text-sm overflow-visible whitespace-normal text-clip'
			}
		},

		modal: {
		slots: {
			// z-20
			overlay: '',
			//  z-30
			content: 'overflow-initial',
			header: 'px-4 py-3 md:px-6 md:py-4 min-h-0 relative',
			body: 'px-4 py-3 md:px-6 md:py-4 fade-in block',
			footer: 'px-4 py-3 md:px-6 md:py-4',
			close: 'top-1/2 -translate-y-1/2'
		},

		variants: {
			fullscreen: {
			true: {
				content:
				'w-full inset-0 lg:inset-4 lg:left-auto lg:w-[calc(100vw-8*var(--spacing))] lg:rounded-xl'
			},

			false: {
				content: 'min-w-md w-auto max-w-none shadow-none'
			}
			}
		}
		},

		breadcrumb: {
		variants: {
			active: {
			true: {
				link: 'text-default max-w-md'
			},

			false: {
				link: 'text-muted max-w-92'
			}
			}
		}
		},

		empty: {
		slots: {
			root: 'p-0 sm:p-0 lg:p-0 min-w-0 gap-3',
			header: 'gap-1'
		},

		defaultVariants: {
			variant: 'ghost',
			size: 'md'
		}
		},

		badge: {
		slots: {
			base: 'min-w-0 max-w-full truncate'
		},

		defaultVariants: {
			variant: 'soft',
			size: 'md'
		}
		},

		button: {
			slots: {
				base: 'justify-center cursor-pointer text-nowrap'
			},

		variants: {
			size: {
				sm: {
					base: 'gap-1.5 py-0 px-2.5 h-10 font-medium'
				},

				md: {
					base: 'gap-1.5 py-0 px-2.5 h-10 font-medium'
				},

				lg: {
					base: 'gap-1 py-0 px-4 h-10 font-medium'
				}
			}
		},

		compoundVariants: [
			{
				color: 'primary',
				variant: 'link',
				class: {
					base: 'py-1.5 h-auto'
				}
			},

			{
				color: 'neutral',
				variant: 'link',
				class: {
					base: 'px-0 py-1.5 h-auto'
				}
			}
		],

		defaultVariants: {
			color: 'primary',
			variant: 'solid',
			size: 'lg'
		}
		},

		switch: {
		slots: {
			root: 'h-10 items-center',
			base: 'cursor-pointer'
		}
		},

		commandPalette: {
		slots: {
			content: 'w-full'
		}
		},

		avatar: {
			slots: {
				root: '',
				fallback: 'flex w-full h-full items-center justify-center text-xs font-semibold !text-inherit rounded-full'
			}
		},

		user: {
			slots: {
				root: 'overflow-hidden justify-start text-left',
				wrapper: 'overflow-hidden',
				name: 'truncate',
				avatar: '!text-inherit',
				description: 'truncate'
			},

		variants: {
			size: {
			md: {
				root: 'gap-2.5',
				name: 'text-sm',
				description: 'text-xs'
			}
			}
		}
		},

		table: {
		slots: {
			root: 'h-full',
			base: '',
			th: 'truncate h-10 py-0 px-2.5 sm:first:pl-4 sm:last:pr-4',
			td: 'truncate h-12 text-default py-0 px-2.5 sm:first:pl-4 sm:last:pr-4',
			tr: 'data-[selected=true]:bg-elevated/50 [&:not(:has(>th)):not(:has(>td:not(:empty)))]:hidden px-4'
		}
		},

		navigationMenu: {
		variants: {
			orientation: {
			vertical: {
				list: 'flex flex-col gap-1',
				link: 'py-2.5'
			}
			}
		},

		compoundVariants: [
			{
			orientation: 'vertical',
			collapsed: true,
			class: {
				link: 'px-2.5'
			}
			}
		]
		},

		dropdownMenu: {
		slots: {
			content: 'shadow-none',
			item: 'data-disabled:opacity-40'
		}
		},

		popover: {
			slots: {
				// z-10
				content: ''
			}
		},

		contextMenu: {
		slots: {
			content: 'shadow-none'
		}
		},

		dashboardSidebar: {
		slots: {
			root: 'gap-3 lg:py-6 lg:gap-4',
			header: 'lg:px-6 lg:h-10',
			body: 'lg:px-6 lg:py-0',
			footer: 'lg:px-6 lg:py-0'
		}
		},

		formField: {
			slots: {
				root: 'group font-medium',
				label: 'text-dimmed transition-colors',
				error: 'hidden'
			},
			variants: {
				size: {
					lg: {
						label: 'text-xs',
						hint: 'text-xs opacity-50',
						description: 'text-xs opacity-50'
					}
				}
			},
			defaultVariants: {
				size: 'lg',
			}
		},

		input: {
			slots: {
				root: 'w-full',
				base: 'truncate focus:truncate-none',
				label: 'text-xs'
			},

			variants: {
				size: {
					lg: {
						base: 'h-10 px-4',
					}
				}
			},

			defaultVariants: {
				variant: 'soft',
				size: 'lg'
			}
		},

		inputNumber: {
			slots: {
				base: 'font-medium',
			},

		variants: {
			orientation: {
				vertical: {
					increment: '-top-1 [&>button]:p-1 pe-0 [&>button]:h-auto [&>button]:w-auto',
					decrement: '-bottom-1 [&>button]:p-1 pe-0 [&>button]:h-auto [&>button]:w-auto'
				},

				horizontal: {
					increment: 'top-0 pe-2',
					decrement: 'bottom-0 ps-2'
				}
			}
		},

		compoundVariants: [
			{
				size: 'lg',
				orientation: 'vertical',
				class: {
					base: 'h-10',
				}
			},
			{
				size: 'lg',
				orientation: 'horizontal',
				class: {
					base: 'h-10',
				}
			}
		],

		defaultVariants: {
			variant: 'soft',
			size: 'lg'
		}
		},

		inputDate: {
		slots: {
			base: 'font-medium'
		},

		variants: {
			size: {
				lg: {
					base: 'h-10'
				}
			}
		},

		defaultVariants: {
			variant: 'soft',
			size: 'lg'
		}
		},

		textarea: {
		slots: {
			root: 'w-full'
		},

		variants: {
			size: {
			lg: {
				base: 'min-h-10'
			}
			}
		},

		defaultVariants: {
			variant: 'soft',
			size: 'lg'
		}
		},

		select: {
		slots: {
			content: 'min-w-fit',
			item: 'items-center'
		},

		variants: {
			size: {
			lg: {
				base: 'h-10 px-4'
			}
			}
		},

		defaultVariants: {
			size: 'lg',
			variant: 'soft'
		}
		},

		selectMenu: {
		slots: {
			content: 'min-w-fit',
			item: 'items-center truncate'
		},

		variants: {
			size: {
			lg: {
				base: 'h-10 px-4'
			}
			}
		},

		defaultVariants: {
			size: 'lg',
			variant: 'soft'
		}
		},

		checkbox: {
			slots: {
				root: 'group',
				base: 'cursor-pointer bg-accented/50 group-hover:bg-accented data-[state=checked]:!bg-primary ring-0 border !border-transparent group-aria-[invalid=true]/fieldset:!border-error transition-[background]',
				indicator: '!bg-transparent zoom-in-bounce',
				label: 'cursor-pointer group-hover:text-highlighted group-has-disabled:text-toned group-has-disabled:opacity-75 group-has-disabled:cursor-not-allowed transition',
				description: 'text-sm cursor-default select-none group-has-disabled:opacity-75 group-has-disabled:cursor-not-allowed'
			},

			variants: {
				disabled: {
					true: {
						base: '!bg-accented/50 group-aria-[invalid=true]/fieldset:!border-transparent'
					}
				}
			},

			defaultVariants: {
				size: 'lg'
			}
		},

		radioGroup: {
		slots: {
			fieldset: 'group/fieldset',
			item: 'group',

			base: 'cursor-pointer bg-accented/50 group-hover:bg-accented data-[state=checked]:!bg-primary ring-0 border !border-transparent group-aria-[invalid=true]/fieldset:!border-error transition-[background]',

			indicator:
			'!bg-transparent after:bg-[var(--ui-text-inverted)] zoom-in-bounce transition',

			label:
			'cursor-pointer group-hover:text-highlighted group-has-disabled:text-toned group-has-disabled:opacity-75 group-has-disabled:cursor-not-allowed transition',

			description:
			'text-sm cursor-default select-none group-has-disabled:opacity-75 group-has-disabled:cursor-not-allowed'
		},

		variants: {
			size: {
			xl: {
				fieldset: 'items-start gap-y-2'
			}
			},

			disabled: {
			true: {
				base: '!bg-accented/50 group-aria-[invalid=true]/fieldset:!border-transparent'
			}
			}
		}
		}
	}
})
